<div class="navbar">
    <div class="tabs">
        @for (item of navItems; track $index) {
            <div
                tabindex="0"
                class="tab"
                role="tab"
                [attr.data-id]="item.id"
                [attr.data-qa]="item.dataQa"
                [matMenuTriggerFor]="item.isMenu ? tabItemMenu : null"
                [class.active]="item.id === activeNavItem"
                [routerLink]="item.route || null"
                (click)="setActiveItem(item)"
                (keyup.enter)="setActiveItem(item)"
                (keypress)="setActiveItem(item)">
                <mat-icon class="tab-icon" [svgIcon]="item.icon" />
                {{ item.label }}
                @if (item.isMenu) {
                    <mat-icon svgIcon="chevron-down" style="display: none" />
                }
                <mat-menu #tabItemMenu="matMenu">
                    @if (item.menuTemplate) {
                        <ng-container *ngTemplateOutlet="item.menuTemplate" />
                    }
                </mat-menu>
            </div>
        }
    </div>
    <span class="spacer"></span>
    @if (menuTemplate) {
        <ng-container>
            <ng-container *ngTemplateOutlet="menuTemplate" />
        </ng-container>
    }
</div>
